const genericError = "There was a problem submitting your payment"

export default function SubscriptionHelper({ subscriptionsPath, planId, productId }) {
  /**
   * @public
   * @param {{billing_details: {name: String, email: String}, card: StripeCardElement}|PaymentMethod} paymentMethodData
   * @param promoCode
   * @param price
   * @param onSuccess
   * @param onError
   */
  async function subscribe({ paymentMethod, promoCode, priceId, onSuccess, onError }) {
    await fetch(subscriptionsPath, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": window.App.authenticityToken,
      },
      body: JSON.stringify({
        plan_id: planId,
        product_id: productId,
        payment_method: paymentMethod.id,
        promo_code: promoCode,
        price_id: priceId,
      }),
      redirect: "error",
    })
      .then(async result => {
        const payload = await result.json().catch(() => ({}))
        return { payload, status: result.status, ok: result.ok }
      })
      .then(async ({ payload, status, ok }) => {
        const { error, errors, subscription, permissions } = payload
        const subscriptionError = error || (errors && errors[0]) || (!ok && { message: `Checkout failed (${status})` })

        if (subscriptionError) {
          onError(subscriptionError)
        } else if (subscription?.status === "active" || subscription?.status === "trialing") {
          onSuccess(subscription, permissions, planId, promoCode)
        }
      })
      .catch(unexpectedError => {
        if (window.App.allowDebugErrorMessages) console.error(unexpectedError)

        if (window.App?.Sentry?.captureException) {
          const err =
            unexpectedError instanceof Error
              ? unexpectedError
              : new Error(typeof unexpectedError === "string" ? unexpectedError : "subscribe fetch failed")
          window.App.Sentry.captureException(err, {
            tags: { product_area: "subscriptions", checkout: "subscribe_fetch" },
            extra: { raw: unexpectedError },
          })
        }

        onError(genericError)
      })
  }

  return { subscribe }
}
